<template>
    <Card >
      <AjaxForm v-if="tr" :route="'admin/MarketProductAttr/Edit/'+id">
            <CustomInput placeholder="عنوان..."
                         label="عنوان"
                         type="text"
                         :model-value="tr.title"
                         name="title"></CustomInput>
        <div class="row mt-2">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block" type="submit">ویرایش اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <div v-else-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import vSelect from 'vue-select'
import {mapActions} from "vuex";
export default {
  name: "MarketProductAttrEdit",
  components: {CustomInput, AjaxForm, Card, MasterLayout,vSelect},
  data(){
    return{
      id : this.$route.params.id,
      tr : null,
      error : null,
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش ویژگی محصول بازار');
    this.setShowHead(true);
    this.initPage();
  },
  methods :{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.error = null;
      this.tr = null;
      this.id = this.$route.params.id;
      const result = await AppApi.getMarketProductAttrInfo(this.id);
      if (result.ok)
      {
        this.tr = result.tr;
      }
      else
      {
        this.error = result.error;
      }
    }
  }
}
</script>

<style scoped>

</style>